import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';

import Pagination from '../../Pagination/Paginations.js';
import EntriesSelector from '../../Pagination/EntriesSelector';

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const UrlControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const emptyUser={
		url_name: "",
		url_link: "",
		parent: ""
	}

	const [user, setUser] = useState({
		url_name: "",
		url_link: "",
		parent: ""
	})

	const handelInput = (event) => {
		event.preventDefault();
		const { name, value } = event.target;
		console.log(name, value)
		setUser({ ...user, [name]: value });
	}



	const [url_name, setUrlname] = useState('');
	const [url_id, setUrlid] = useState('');
	const [url_link, setUrllink] = useState('');
	const [parent, setParent] = useState('');
	const history = useHistory();
	const [data, setData] = useState([]);
	const [datacount, setDataCount] = useState([]);
	const [dataval, setdataval] = useState([]);
	const [currentPageId, setCurrentPageId] = useState(1);


	// const [anand, setAnand]= useState([]);
	const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
	
	let filteredItems = data.filter((item) =>



		`${item.name.toLowerCase()}${item.link.toLowerCase()}${item.parent.toLowerCase()}`.includes(searchTerm.toLowerCase())

	);
	const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
	const indexOfLast = currentPage * entriesPerPage;
	const indexOfFirst = indexOfLast - entriesPerPage;
	const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

	const startIndex = (currentPage - 1) * entriesPerPage;



	const handleSearch = (event) => {
		setSearchTerm(event.target.value);
	};


	const clearInput = () => {
		setSearchTerm("");
	  };






	useEffect(() => {
		axios.get(API_BASE_URL + '/fetchurl', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			.then(res => setData(res.data))
			//.then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])




	useEffect(() => {
		handleUpdate();
	}, []);

	var elements = [];
	for (var i = 1; i <= datacount.total_page; i++) {
		elements.push(i);
	}

	//   for(var i=1;i<=datacount.total_page;i++){
	// 	elements.push(<li className="page-item"><a className="page-link" href="" onClick={() => handlePagination(i)}>
	// 	  {i}
	//   </a></li>);
	// }

	//console.log(elements)

	//   const [currentPage,setCurrentPage]= useState(1);
	




	// const paginate= (page) => setCurrentPage(page); 

	const handleUpdate = async (id) => {

		axios.get(API_BASE_URL + '/showurl/' + id, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
			.then(res1 => setUser(res1.data))
			.catch(err => console.log(err))
	};


	const handlePagination = async (numpage) => {
		// alert('hi');
		// alert(numpage);
		axios.get(API_BASE_URL + '/fetchurl?per_page=10&page_num=' + numpage, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
			.then(res1 => setData(res1.data))
			.catch(err => console.log(err))
	};

	//    useEffect(() => {
	// 	handlePagination(1);
	//   }, []);


	const handleSubmit = async (e) => {

		e.preventDefault();
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL + '/url', { url_name: user.url_name, url_link: user.url_link, parent: user.parent }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// 	console.log(response.data);
			// 	console.log(response.data.message);
			// })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});


				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};



	const handleEditSubmit = (e) => {

		e.preventDefault();

		console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL + '/updateurl', { url_name: user.url_name, url_link: user.url_link, parent: user.parent, id: user.id }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};


	// const [globalFilterText,setGlobalFilterText]=useState();

	// const handleGlobalFilter=(e)=>{

	// 	const value= e.target.value || '';
	// 	setGlobalFilterText(value);

	// };

	// const filteredData=data.filter((row)=>{
	// return Object.values(row).some((value)=> value.toString().toLowerCase().includes(globalFilterText.toLowerCase())
	// );
	// }); 




	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
							<div className="d-flex justify-content-end align-items-center mb-3">
								<div className="header-action">
									<div id="button">
										<button style={{ float: 'center' }}
											type="button"
											className="btn btn-primary"
											data-toggle="modal"
											data-target="#exampleModal"
											onClick={()=>{setUser(emptyUser)}}
										>
											<i className="fe fe-plus mr-2" />
											Add
										</button>
									</div>
								</div>
							</div>

						</div>
					</div>


					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">
										<div className="card-header">
											<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
												<i className="fa fa-link mr-2" style={{ fontSize: "20px" }} />
												Url List
											</h3>
											<div className="card-options" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px' }}>

												<div className="input-group">

													<EntriesSelector style={{
																padding: '1px',
																marginRight: '20px',
																borderRadius: '4px',
																border: '1px solid #ccc',
																backgroundColor: '#BCD1DB',display: 'flex', justifyContent: 'left'
															  }}
        setEntriesPerPage={setEntriesPerPage}
        setCurrentPage={setCurrentPage}
      />

													<div style={{ position: "relative", width: "300px", marginLeft: "20px" }}>

													<input
														type="text"
														className="form-control form-control-sm"
														placeholder="Search"
														value={searchTerm}
														onChange={e => {
																setSearchTerm(e.target.value);
																setCurrentPage(1);
																}}  
														style={{
															width: "100%",
															padding: "5px 0px 4px 0px",
															paddingRight: "30px", // Extra space for the clear icon
															boxSizing: "border-box",
														  }}
														// style={{ padding: '8px', width: '200px', borderRadius: '4px', border: '1px solid #ccc' }}
													/>

 {searchTerm.length>0 && ( 
        <span
          onClick={clearInput}
          style={{
            position: "absolute",
			top: "50%",
			right:"10px",
			transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#aaa",
            fontSize: "18px",
			// marginLeft: '260px !important',
            
          }}
        >
          ✖
        </span>
       )}
	    </div>



												</div>

											</div>
										</div>












										<div className="card-body">
											<div className="table-responsive sticky-table-wrap" style={{ maxHeight: "420px" }}>
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0 sticky-table">
													<thead>
														<tr>
															<th>S.No</th>
															<th>Url Name</th>
															<th>Url Link</th>
															<th>Parent</th>
															{/* <th>Join Date</th>
															<th>Role</th> */}
															<th>Action</th>
														</tr>
													</thead>
													<tbody>



														{
															filteredData.map((url, index) => {

																return <tr key={index}>
																	<td>
																		<span
																			className=""
																			data-toggle="tooltip"
																			data-original-title="Avatar Name"
																		>
																			{startIndex + index + 1}
																		</span>

																	</td>
																	<td>
																		<span>{url.name}</span>
																	</td>
																	<td>
																		<span>{url.link}</span>
																	</td>
																	<td>
																		<span>{url.parent}</span>
																	</td>

																	<td>



																		<button
																			type="button" onClick={() =>{ handleUpdate(url.id);setUser(emptyUser)}}
																			className="btn btn-icon btn-sm"
																			title="Edit" data-toggle="modal"
																			data-target="#exampleEditModal"
																		>
																			<i className="fa fa-edit" />
																		</button>

																	</td>
																</tr>


															})
														}

													</tbody>
												</table>
											</div>



											  <Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>				









										</div>
									</div>
								</div>


							</div>
						</div>
					</div>

				</div>
			</div>





			<div
				className="modal fade"
				id="exampleModal"
				tabIndex={-1}
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<form onSubmit={handleSubmit}>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="exampleModalLabel">
									Add URL
								</h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="row clearfix">
									<div className="col-md-4 col-sm-6">
										<div className="form-group required-tooltip">
										<label className="form-label">Url Name</label>
											<input type="text" className="form-control required-input" name="url_name" value={user.url_name}
												onChange={handelInput} placeholder="Url Name" />
										</div>
									</div>
									<div className="col-md-4 col-sm-6">
										<div className="form-group required-tooltip">
										<label className="form-label">Url Link</label>
											<input type="text" className="form-control required-input" name="url_link" value={user.url_link}
												onChange={handelInput} placeholder="Url Link" />
										</div>
									</div>
									<div className="col-md-4 col-sm-6">
										<div className="form-group required-tooltip">
										<label className="form-label">Parent</label>
											<input type="text" className="form-control required-input" name="parent" value={user.parent}
												onChange={handelInput} placeholder="Parent" />
										</div>
									</div>

								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-secondary" data-dismiss="modal">
									Close
								</button>
								<button type="submit" className="btn btn-primary btn-sm">
									Save
								</button>
							</div>
						</div>
					</div>

				</form>

			</div>




			<div
				className="modal fade"
				id="exampleEditModal"
				tabIndex={-1}
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<form onSubmit={handleEditSubmit}>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="exampleModalLabel">
									Add URL
								</h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="row clearfix">
									<div className="col-md-4 col-sm-6">
										<div className="form-group required-tooltip">
										<label className="form-label">Url Name</label>
											<input type="text" className="form-control required-input" name="url_name" value={user.url_name}
												onChange={handelInput} placeholder="Url Name" />
										</div>
									</div>
									<div className="col-md-4 col-sm-6">
										<div className="form-group required-tooltip">
										<label className="form-label">Url Link</label>
											<input type="text" className="form-control required-input" name="url_link" value={user.url_link}
												onChange={handelInput} placeholder="Url Link" />
										</div>
									</div>
									<div className="col-md-4 col-sm-6">
										<div className="form-group required-tooltip">
										<label className="form-label">Parent</label>
											<input type="text" className="form-control required-input" name="parent" value={user.parent}
												onChange={handelInput} placeholder="Parent" />
										</div>
									</div>

								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-secondary" data-dismiss="modal">
									Close
								</button>
								<button type="submit" className="btn btn-primary btn-sm">
									Save
								</button>
							</div>
						</div>
					</div>

				</form>

			</div>




			<div
				className="modal fade"
				id="exampleEditModal1"
				tabIndex={-1}
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<form onSubmit={handleEditSubmit}>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="exampleModalLabel">
									Edit URL
								</h5>

								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>



							<div className="card-body">
								<div className="table-responsive">
									<div>
										{
											dataval.map((user, index) => {

												return <div key={index}>

													<div className="modal-body">
														<div className="row clearfix">
															<div className="col-md-4 col-sm-6">
																<div className="form-group">
																	<input type="text" className="form-control required-input" name="url_name" value={user.url_name}
																		onChange={handelInput} placeholder="Url Name" />

																	<input name="id" value={user.id} type="hidden" />

																</div>
															</div>


															<div className="col-md-4 col-sm-6">
																<div className="form-group">
																	<input type="text" className="form-control required-input" name="url_link" value={user.url_link}
																		onChange={handelInput} placeholder="Url Link" />
																</div>
															</div>

															<div className="col-md-4 col-sm-6">
																<div className="form-group">
																	<input type="text" className="form-control required-input" name="parent" value={user.parent}
																		onChange={handelInput} placeholder="Parent" />
																</div>
															</div>


															<div className="modal-footer">
																<button type="button" className="btn btn-secondary" data-dismiss="modal">
																	Close
																</button>
																<button type="submit" className="btn btn-primary btn-sm">
																	Save
																</button>
															</div>

														</div>
													</div>

												</div>

											})
										}

									</div>
								</div>
							</div>
						</div>
					</div>

				</form>

			</div>






		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(UrlControl);